import { LoginForm } from '@on3/ui-lib/components/Auth/Forms/Login';
import { useSite } from '@on3/ui-lib/index';
import { useRouter, useSearchParams } from 'next/navigation';

import styles from './AuthPage.module.scss';

export const LoginPage = () => {
  const { currentSite } = useSite();
  const params = useSearchParams();
  const returnTo = params.get('returnTo') || currentSite.url || '/';

  const router = useRouter();

  return (
    <div className={styles.block}>
      <LoginForm callback={() => router.push(returnTo)} />
    </div>
  );
};
